import { connect } from "react-redux";
import { PageHome } from "senac-components";
import {
  PageHomePropsDispach,
  PageHomeState,
} from "senac-components/dist/pages/Mobile/PageHome";
import { PageHomeWeb } from "senac-components/dist/pages/Web/PageHome";
import { MenuOptions } from "senac-components/dist/pages/Mobile/PageInterfaces";
import { AppDispatch, RootState } from "../store";
import { commonSlice } from "../store/reducers";
import { useEffect, useState } from "react";

const mapState = (state: RootState) => {
  let result: PageHomeState = {};
  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageHomePropsDispach = {
    onClickCollection: () =>
      dispatch(commonSlice.actions.goToPage(MenuOptions.Home)),
    onClickForgotMyPassword: () =>
      dispatch(commonSlice.actions.recoverPassword()),
    onClickHelp: () => dispatch(commonSlice.actions.helpPage()),
    onClickLogin: () => dispatch(commonSlice.actions.loginPage()),
    onClickRegister: () => dispatch(commonSlice.actions.registerPage()),
  };
  return result;
};

const WPageHome = () => {
  const [initialized, setInitialized] = useState(true);

  useEffect(() => {
  }, []);

  const Mobile = connect(mapState, mapDispatch)(PageHome);
  const Web = connect(mapState, mapDispatch)(PageHomeWeb);

  if (!initialized) return null;

  if (window.innerWidth < 1024) return <Mobile />;
  return <Web />;
};

export { WPageHome };
